import { Form, Formik, FormikHelpers } from 'formik';
import { IoSave } from 'react-icons/io5';
import { changePasswordFromSchema } from '../../../schemas';
import AcademiaButton from '../Buttons/AcademiaButton';
import AcademiaInputField from '../Inputs/AcademiaInputField';
import PasswordRestrictionRules from '../PasswordRestrictionRules';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const ChangePasswordModal = ({
  handleModalClose,
  changePasswordFn,
  isRequestedFromUser,
  hideCloseButton,
  isFirstLogin,
}: {
  changePasswordFn: (values: any, actions: FormikHelpers<any>) => void;
  handleModalClose: () => void;
  isRequestedFromUser?: boolean;
  isFirstLogin?: boolean;
  hideCloseButton?: boolean;
}) => {
  console.log(isFirstLogin);
  // rendering change password modal component here
  return (
    <ParentModal
      onClick={handleModalClose}
      hideCloseButton={hideCloseButton}
      makeBgBlur={isFirstLogin}
    >
      <ModalTitle titleText='change password' />

      {isFirstLogin ? (
        <p className='text-base-dark-blue'>
          You are using a{' '}
          <span className='font-medium text-base-light-blue'>
            system generated password
          </span>
          . Please, change your password to a memorable one in order to avoid
          security breech.
        </p>
      ) : null}

      <Formik
        initialValues={{
          is_user: isRequestedFromUser || false,
          current_password: '',
          new_password: '',
          confirm_password: '',
        }}
        validationSchema={changePasswordFromSchema}
        onSubmit={changePasswordFn}
      >
        {(props) => (
          <Form className='space-y-5'>
            {isRequestedFromUser ? (
              <AcademiaInputField
                type='password'
                name='current_password'
                label='Current Password'
                placeholder='Enter current password here...'
                isRequired={isRequestedFromUser}
              />
            ) : null}

            <div>
              <AcademiaInputField
                type='password'
                name='new_password'
                label='New Password'
                placeholder='Enter new password here...'
                isRequired
              />

              <PasswordRestrictionRules
                password={props.values.new_password}
                isTouched={!!props.touched.new_password}
                error={props.errors.new_password}
              />
            </div>

            <AcademiaInputField
              type='password'
              name='confirm_password'
              label='Confirm Password'
              placeholder='Retype new password to confirm here...'
              isRequired
            />

            <AcademiaButton
              type='submit'
              variant='premium'
              icon={<IoSave className='size-5' />}
              isLoading={props.isSubmitting}
              fullWidth
            >
              Save New Password
            </AcademiaButton>
          </Form>
        )}
      </Formik>
    </ParentModal>
  );
};

export default ChangePasswordModal;
